import { render, staticRenderFns } from "./image.vue?vue&type=template&id=5f13e7b0"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f13e7b0')) {
      api.createRecord('5f13e7b0', component.options)
    } else {
      api.reload('5f13e7b0', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=5f13e7b0", function () {
      api.rerender('5f13e7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/types/image.vue"
export default component.exports